import { render, staticRenderFns } from "./BDUPGHDR.vue?vue&type=template&id=6e3044f0&scoped=true"
import script from "./BDUPGHDR.vue?vue&type=script&lang=js"
export * from "./BDUPGHDR.vue?vue&type=script&lang=js"
import style0 from "./BDUPGHDR.vue?vue&type=style&index=0&id=6e3044f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3044f0",
  null
  
)

export default component.exports